<template>

  <data-form
    model="users"
    :entity="user"
    :fields="fields"
    :after-submit="afterSubmit"
    ignoreEntityChanges
  />

</template>

<script>
export default {
  name: 'user-form',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    fields () {
      const fields = {
        'email': {
          type: 'email',
          rules: [{ required: true }, { max: 254 }, { type: 'email' }]
        },
        'first_name': {
          type: 'text',
          rules: [{ required: true }, { max: 50 }]
        },
        'last_name': {
          type: 'text',
          rules: [{ required: true }, { max: 50 }]
        },
        'phone': {
          type: 'text',
          rules: [{ max: 16 }]
        },
        'password': {
          type: 'password',
          rules: [{ required: this.user.new }, { max: 254 }]
        }
      }

      return fields
    }
  },
  methods: {
    afterSubmit (formModel) {
      this.$router.back()
    }
  }
}
</script>


// WEBPACK FOOTER //
// UserForm.vue?7877bdc0